
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9 .667C4.405.667.667 4.405.667 9c0 4.595 3.738 8.333 8.333 8.333 4.595 0 8.333-3.738 8.333-8.333C17.333 4.405 13.595.667 9 .667zm0 15A6.675 6.675 0 012.333 9 6.674 6.674 0 019 2.333 6.674 6.674 0 0115.667 9 6.674 6.674 0 019 15.667z","fill":"#7E8186"}}),_c('path',{attrs:{"d":"M8.167 8.167h1.666v5H8.167v-5zm0-3.334h1.666V6.5H8.167V4.833z","fill":"#7E8186"}})])
          )
        }
      }
    